import React, { useCallback } from 'react';
import { chatStyles } from '@zonofi/chats-common/styles';
import { MessageEnvelope } from '@zonofi/common/schema/message/inferface';
import { displayDateTime } from '@zonofi/common/functions/datetime-operations';
import { colors } from '@zonofi/common/theme/colors';
import { WhatsappChatItem } from './components';
import './whatsapp-chat-simulator.scss';
import {
  getShowTypingIndicator,
  useAppSelector,
} from '@zonofi/seller-rtk-store';
// import { MenuItem } from '../../common/interface';

interface WhatsappChatSimulatorProps {
  changeToZonoMoneySimulator?: (url: string) => void;
  chatContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  groupedMessages: any[];
  onMenuClick: (val: any[], msgId: string) => void;
  publishQuickReply: (contextId: string, text: string) => void;
  publishReaction: (contextId: string, text: string, replyText: string) => void;
  sendSampleQuestion: (val: string) => void;
}

export const WhatsappChatSimulator: React.FC<WhatsappChatSimulatorProps> = ({
  changeToZonoMoneySimulator,
  chatContainerRef,
  groupedMessages,
  onMenuClick,
  publishQuickReply,
  publishReaction,
  sendSampleQuestion,
}) => {
  const scrollToItem = useCallback(
    (key: string) => {
      if (
        !groupedMessages.some(
          (msg) => typeof msg === 'object' && msg?.message?._id === key
        )
      ) {
        console.warn('Message not found in allMessages, skipping scroll');
        return;
      }

      const ref = chatContainerRef;
      const item = ref?.current?.querySelector(
        `[data-key="${key}"]`
      ) as HTMLElement | null;

      if (item && ref?.current) {
        const parent = ref.current;

        const parentHeight = parent.clientHeight;
        const itemTop = item.offsetTop;
        const itemHeight = item.clientHeight;

        const scrollPosition = itemTop - parentHeight / 2 + itemHeight / 2;
        parent.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        console.warn('Message element not found in DOM, skipping scroll');
      }
    },
    [groupedMessages]
  );

  const isTyping = useAppSelector(getShowTypingIndicator);

  const typingIndicatorBubble = () => {
    return (
      <div
        className={`whatsapp-chat-item flexColumnAlStart sender primary-font-regular`}
        data-key={''}
      >
        <div
          className={`message-template tertiary-font-regular whatsapp-chat-item-body ${'sender-chat-item'}`}
        >
          <div className="bouncing-loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="whatsapp-chat-simulator" ref={chatContainerRef}>
      {isTyping && typingIndicatorBubble()}
      {groupedMessages.map((item: MessageEnvelope, index) => {
        if (typeof item === 'string') {
          return (
            <div
              className="dateSeparator comms-font-size-regular tertiary-font-semibold"
              style={{
                ...chatStyles.fontSemiBold12Secondary,
                borderColor: colors.gainsboro,
              }}
            >
              {displayDateTime(item, 'date')}
            </div>
          );
        } else {
          return (
            <WhatsappChatItem
              changeToZonoMoneySimulator={changeToZonoMoneySimulator}
              envelope={item}
              key={item.timetoken as string}
              onMenuClick={onMenuClick}
              publishQuickReply={publishQuickReply}
              publishReaction={publishReaction}
              scrollToItem={scrollToItem}
              sendSampleQuestion={sendSampleQuestion}
            />
          );
        }
      })}
    </div>
  );
};
